import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource-variable/outfit'
import './styles/tokens.css'
import './styles/base.css'
import './styles/cosmetics.css'
import sprite from './assets/sprite.svg?raw'
import { App } from './app/App'
import { applyPrefs } from './lib/prefs'
import { primeAudio } from './lib/sound'

document.body.insertAdjacentHTML('afterbegin', sprite)
applyPrefs()
primeAudio()

// draw once the main font is in (it's preloaded, so this is usually instant), never waiting more than 600 ms
const fontIn = document.fonts?.load ? Promise.all([document.fonts.load('800 16px "Outfit Variable"'), document.fonts.load('500 16px "Outfit Variable"')]).catch(() => {}) : Promise.resolve()
void Promise.race([fontIn, new Promise((r) => setTimeout(r, 600))]).then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
